'use strict';

var escape = require('lodash/escape');
var R = require('ramda');

var attributePair = function attributePair(key, value) {
    return !!value ? key + '="' + escape(value) + '"' : '';
};

var ampScript = '<script async src="https://cdn.ampproject.org/v0.js"></script>';

var ampBoilerplateStyle = '<style amp-boilerplate>body{-webkit-animation:-amp-start 8s steps(1,end) 0s 1 normal both;-moz-animation:-amp-start 8s steps(1,end) 0s 1 normal both;-ms-animation:-amp-start 8s steps(1,end) 0s 1 normal both;animation:-amp-start 8s steps(1,end) 0s 1 normal both}@-webkit-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@-moz-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@-ms-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@-o-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}</style><noscript><style amp-boilerplate>body{-webkit-animation:none;-moz-animation:none;-ms-animation:none;animation:none}</style></noscript>';

function htmlPage(_ref) {
    var title = _ref.title,
        _ref$metaHTML = _ref.metaHTML,
        metaHTML = _ref$metaHTML === undefined ? '' : _ref$metaHTML,
        _ref$bodyClasses = _ref.bodyClasses,
        bodyClasses = _ref$bodyClasses === undefined ? [] : _ref$bodyClasses,
        bodyHTML = _ref.bodyHTML,
        language = _ref.language,
        _ref$amp = _ref.amp,
        amp = _ref$amp === undefined ? false : _ref$amp;

    return '<!doctype html>\n<html' + (amp ? ' amp' : '') + attributePair('lang', language) + '>\n<head>\n<meta charset="utf-8">' + (amp ? ampScript : '') + '\n<meta name="viewport" content="width=device-width, initial-scale=1">\n<title>' + escape(title) + '</title>\n' + (amp ? '' : metaHTML) + (amp ? ampBoilerplateStyle : '') + '\n</head>\n<body class="' + bodyClasses.join(' ') + '">\n' + bodyHTML + '\n</body>\n</html>\n';
}

module.exports = htmlPage;


//////////////////
// WEBPACK FOOTER
// ./~/lokum/lib/htmlTemplate.js
// module id = 351
// module chunks = 0